import React, { useEffect, useState, useRef, Suspense } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../../components/Sidebar/Sidebar';
import Thumbnail from '../../assets/images/work/torus/thumbnail.png';
import Persona from '../../assets/images/work/torus/persona.png';
import OverView from '../../assets/images/work/torus/overview.png';
import ShopImage from '../../assets/images/work/torus/shop-img.png';
import Point_1 from '../../assets/images/work/torus/torus_point_1.png';
import Point_2 from '../../assets/images/work/torus/torus_point_2.png';
import Point_3 from '../../assets/images/work/torus/torus_point_3.png';
import { ReactComponent as ExternalLinkIcon } from '../../assets/icons/external_link.svg';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';
import './raiden.css'; 
import '../SinglePost.css';

// ドーナツモデルを読み込むコンポーネント
function Donut() {
    // publicフォルダに配置したdonut.glbファイルを読み込みます
    const { scene } = useGLTF('/donut.glb');
    return <primitive object={scene} />;
}
  

function Torus() {
    // 見出し情報とアクティブな見出しを管理する状態
    const [headings, setHeadings] = useState([]);
    const [activeHeadingId, setActiveHeadingId] = useState(null);

    // コンテンツのDOMを参照するためのref
    const contentRef = useRef(null);

    // ① コンテンツを通常のJSXで記述
    const contentJSX = (
        <div>
            <div className="article-title-block">
                <h1 className="article-title">ドーナツ専門店「TORUS」サイト</h1>
                <div className="article-sub-title"><strong>宇宙×ドーナツが導く、物語で魅せるWeb体験</strong></div>
            </div>
            
            <div className="article-info">
                <div className="use-tool">
                    <strong>使用ツール：</strong>Adobe Photoshop、Illustrator
                </div>
                <div className="product-period">
                    <strong>制作期間：</strong>2ヶ月
                </div>
            </div>

            <div className="thumbnail-block">
                <div>
                    <img 
                        src={Thumbnail} 
                        alt="ドーナツ専門店「TORUS」のサムネイル画像。PCのファーストビューの画像が表示されています。" 
                    /> 
                </div>  
            </div>

            <section className="overview">
                <h2>概要</h2>
                <div className="section-content">
                    <p>
                    架空のドーナツ専門店「TORUS」のサイトを自主制作しました。本作品では、「宇宙✖️ドーナツ」というコンセプトを軸に、ただ商品を紹介するだけではなく、訪れたユーザーが物語に引き込まれ、最後に“ぞっ”とするようなオチへ導かれる構成を目指しました。
                    遊び心のあるUIやアニメーション、情報の見せ方にこだわり、ブランドの背景や商品の魅力が自然と伝わるWeb体験を設計しています。※TOPページのみ実装。
                    </p>
                </div>
                
            </section>

            <section className="shop">
                <h2>お店の基本情報</h2>
                <div className="section-content">
                <div className="shop-info-box">
                    <div className="shop-img"> 
                        <img 
                            src={ShopImage} 
                            alt="架空ドーナツ専門店「TORUS」の店舗イメージが表示されています。" 
                        />
                    </div>    
                    <div  className="shop-description">
                    <h3>火星にあるドーナツ専門店</h3>
                        <p>元・宇宙物理学研究者兼宇宙飛行士の店主が念願だったドーナツ専門店を火星移住プロジェクト第2波のタイミングにあわせて出店。地球から取り寄せた原材料と火星で採取した天然水を使い、ここにしかないドーナツを開発した。</p>
            
                        <div className="shop-list">
                            <p><strong>店舗コンセプト：「宇宙をかけるドーナツ」</strong></p>
                            <ul>
                                <li>食べても眺めてもワクワクする、不思議で美味しいドーナツ体験を提供</li>
                                <li>日常の中に非日常を呼び込む、サプライズとエンターテイメントを重視</li>
                            </ul>
                        </div>
                    </div>
                </div>
                </div>


            </section>

            <section className="task">
                <h2>課題</h2>
                <div className="section-content">
                    <div className="list-block">
                        <h3>認知度が低い</h3>
                        <ul>
                            <li><strong>興味を持つ層には届くが、それ以上に広がらない問題</strong>：「宇宙×ドーナツ」という独自のコンセプトは魅力的だが、現状は興味を持つ層に一時的に話題になっているだけ。</li>
                            <li><strong>味・商品の核心的な良さが伝わらない問題</strong>：火星に店舗があるという特殊性だけが先行し、「本当に美味しいのか？」「どんなドーナツなのか？」といった本質的な魅力が伝わりきらない。</li>
                            <li><strong>ブランドストーリーや独自性が深く伝わらない問題</strong>：訪問者が「ちょっと面白い店が火星にあるらしい」程度の印象で終わり、コンセプトの背景（なぜ宇宙とドーナツなのか？）や商品特有の価値が浸透しづらい。</li>
                        </ul>
                    </div>
                </div>    
            </section>  

            <section className="persona">
                <h2>ペルソナ</h2>
                <div className="section-content">
                    <div className="persona-block">
                        <div className="persona-img">
                        <img 
                            src={Persona} 
                            alt="ペルソナのイメージ画像です。若い女性が表示されています。" 
                        /> 
                        </div>
                        <div className="persona-info">
                            <h4 className="persona-title">繰り返しの日々を生きる、大人になった夢見る少女（20代女性)</h4>
                            <p>
                            新しい体験や非日常な世界観が大好き。SNSで面白いお店を見つけては、興味があればどんな場所でも一度は足を運ぶタイプ。流行り物を追うよりも、その<strong>背景・ストーリーを重視する傾向</strong>があり、推しアイドルを選ぶ際も、誰がプロデュースしているのか、アイドルになった背景や過程を調べ上げてから“推す”か決めるほどのこだわり派。<strong>最近は、繰り返しの日常や日々の業務に追われ、疲弊している。</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </section>   

            <section className="purpose">
                <h2>目的</h2>
                <div className="section-content">
                <p>「宇宙×ドーナツ」という独自のコンセプトを広く伝え、ドーナツ本来の魅力やブランドの背景まで丁寧に届けることで、“一度は食べてみたい”と思わせること。</p>
                </div>


            </section>

            <section className="point">
                <h2>デザインのポイント</h2>
                 <div className="section-content-wide">
                 <div className="point-container normal">
                    <div className="point-img"> 
                        <img 
                            src={Point_3} 
                            alt="TORUSサイトのエピローグ部分が画像として切り抜かれています。。" 
                        />
                    </div>    
                    <div  className="point-description">
                    <h3>ストーリー仕立て</h3>
                        <p>サイト全体にストーリーを持たせるために、プロローグとエピローグを設置しました。サイトを最後まで読み進んでいくことで、ファーストビューのキャッチコピーの意味がわかるようにしています。これは、<strong>コンセプトの背景を自然に伝えつつ、ペルソナの“物語重視”な志向に応えています。</strong></p>
                    </div>
                </div>



                <div className="point-container reverse"> 
                    <div  className="point-description">
                        <h3>ドーナツの特徴やこだわりを、遊び心のあるパーツで表示</h3>
                        <p>ドーナツをデータ解析する風のパーツで、「宇宙」という世界観に違和感なく溶け込みながら、<strong>商品の魅力を楽しく・視覚的に伝える</strong>仕掛けをしました。</p>
                    </div>
                    <div className="point-img">    
                        <img 
                            src={Point_2} 
                            alt="TORUSサイトのドーナツについての紹介部分が画像して切り抜かれています。" 
                        /> 
                    </div>
                </div>


                <div className="point-container normal">
                    <div className="point-img"> 
                        <img 
                            src={Point_1} 
                            alt="TORUSサイトのお店のコンセプト紹介の部分が画像として切り抜かれています。" 
                        />
                    </div>    
                    <div  className="point-description">
                    <h3>宇宙空間に引き込まれるような体験を演出</h3>
                        <p>GSAP、Swiper、particle.jsを用いて宇宙空間を演出。デブリが浮遊し、隕石が流れるような動きによって、ユーザーの目線を自然に誘導しながら、サイト全体への没入感を高めています。<strong>宇宙を旅しているかのような感覚を演出することで、一過性の“話題”ではなく“印象に残る体験”としてブランドを記憶に残す</strong>ことができます。</p>
                    </div>
                </div>


                 </div>
                

            </section>

            <section class="overview">
                <div>
                <img 
                    src={OverView} 
                    alt="TORUSサイトの全体像が表示されています。" 
                />

                </div>

            </section>

            <section className="summary">
                <h2>学んだこと</h2>
                <div className="section-content">
                    <p>今回の制作を通じて、「デザインの面白さ」だけでなく「伝える構成」の難しさを実感しました。一時的な話題性や派手さに頼るのではなく、誰に届けたいか／何を伝えたいかを整理し、そのために必要な情報の見せ方や演出を考えることが、結果として世界観の説得力につながることを学びました。
特に、「読み進めたくなるストーリー構成」や「商品に目を向けてもらう仕掛け」は、今後の作品でも意識して取り入れていきたいです。</p>
                </div>
                

            </section>

            <section>
            <div className="section-content">
            <p>実際のサイトは、以下のリンクからアクセスできます。</p>
            <a  className="site-link"
                href="https://torus.chiho-tsuda.com" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="ドーナツ専門店 TORUS の実際のサイトを新しいタブで開きます"
            >
                ドーナツって宇宙だ。ドーナツ専門店「TORUS」
                <ExternalLinkIcon className="external-link-icon" />
            </a>

            </div>

            </section>
            
        

        </div>
        
    );

    // ② コンテンツレンダリング後にrefから見出しを抽出する
  useEffect(() => {
    if (contentRef.current) {
      // querySelectorAllでh2, h3, h4タグを取得
      const headingEls = contentRef.current.querySelectorAll('h2, h3, h4');
      const extractedHeadings = [];
      headingEls.forEach((el, index) => {
        // IDがなければ自動で設定する
        if (!el.id) {
          el.id = `heading-auto-${index + 1}`;
        }
        // タグ名からレベルを数値として取得
        const level = parseInt(el.tagName.substring(1), 10);
        extractedHeadings.push({
          id: el.id,
          text: el.innerText,
          level: level,
        });
      });
      setHeadings(extractedHeadings);
    }
  }, []); // 一度だけ実行

  // ③ スクロールイベントでアクティブな見出しを更新（オプション）
  useEffect(() => {
    function handleScroll() {
      let currentActive = null;
      let minDistance = Infinity;
      headings.forEach(h => {
        const el = document.getElementById(h.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          const distance = Math.abs(rect.top);
          if (distance < minDistance) {
            minDistance = distance;
            currentActive = h.id;
          }
        }
      });
      setActiveHeadingId(currentActive);
    }
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [headings]);

  // ④ クリック時に対象の見出しへスクロールする処理
  const handleClickHeading = (headingId) => {
    const el = document.getElementById(headingId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };


    return (
        <div className="single-post-container">
      
        <div className="single-post-main"> 
          <div className="back-to-home">
            <Link to="/" className="back-link">← Homeへ戻る</Link>
          </div>

          <div className="single-post-content" ref={contentRef}>
            {contentJSX}
          </div>


        {/* Canvas部分にドーナツの3Dモデル表示を追加 */}
        {/*}
        <Canvas style={{ width: '100%', height: '100vh' }}>
              <ambientLight intensity={0.5} />
              <directionalLight intensity={0.8} position={[0, 0, 5]} />
              <Suspense fallback={null}>
                <Donut />
              </Suspense>
              <OrbitControls />
        </Canvas>

        */}        

          <div className="back-to-home">
            <Link to="/" className="back-link">← Homeへ戻る</Link>
          </div>

        </div>
  
        <Sidebar
          headings={headings}
          activeHeadingId={activeHeadingId}
          onClickHeading={handleClickHeading}
        />
        
      </div>

    );

}
export default Torus;  